import { render, staticRenderFns } from "./WaitView.vue?vue&type=template&id=02ba38bd"
var script = {}
import style0 from "./WaitView.vue?vue&type=style&index=0&id=02ba38bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports